(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-product-advanced"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.slpCriticalReady === 'true') return;
    root.dataset.slpCriticalReady = 'true';
    const addButton = root.querySelector('[data-slp-add]');
    const mobileAdd = root.querySelector('[data-slp-mobile-add]');
    const mobilePrice = root.querySelector('[data-slp-mobile-price]');
    const shareButton = root.querySelector('[data-slp-share]');
    if (mobileAdd && addButton) {
      mobileAdd.addEventListener('click', () => addButton.click());
      const sync = () => {
        mobileAdd.disabled = addButton.disabled;
        mobilePrice.textContent = root.querySelector('[data-slp-price]')?.textContent || '';
      };
      sync();
      new MutationObserver(sync).observe(addButton, { attributes: true });
      const price = root.querySelector('[data-slp-price]');
      if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });
    }
    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const payload = { title: document.title, text: root.querySelector('.slp__title')?.textContent?.trim() || document.title, url: window.location.href };
        try {
          if (navigator.share) await navigator.share(payload);
          else throw new Error('share-unavailable');
        } catch (error) {
          if (error?.name === 'AbortError') return;
          try {
            await navigator.clipboard.writeText(payload.url);
            const label = shareButton.querySelector('[data-slp-share-label]');
            if (label) {
              const original = label.textContent;
              label.textContent = shareButton.dataset.shareCopied || 'Link copied';
              window.setTimeout(() => { label.textContent = original; }, 2200);
            }
          } catch (clipboardError) {}
        }
      });
    }
  };
  const boot = () => document.querySelectorAll('[data-slp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target?.querySelector?.('[data-slp]') || event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
